<template>
  <div>
    <Breadcrumbs :type="type" :header="title" :url="url"></Breadcrumbs>      
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="form-select mt-1 w-full">
          <option :value="null" />
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
      <Link class="btn-indigo" href="/backend/organograms/create">
        <span>Create</span>
        <span class="hidden md:inline">&nbsp;Office Organograms</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">Designation</th>
            <th class="pb-4 pt-6 px-6">Office Name</th>
            <th class="pb-4 pt-6 px-6">Office Layer Name</th>
            <th class="pb-4 pt-6 px-6">Ministry Name</th>
            <th class="pb-4 pt-6 px-6" colspan="2">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="office in offices.data" :key="office.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-orange-500" :href="`/backend/organograms/${office.id}/edit`">
                {{ office.designation_name }}
                <icon v-if="office.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/backend/organograms/${office.id}/edit`" tabindex="-1">
                {{ office.office_name }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/backend/organograms/${office.id}/edit`" tabindex="-1">
                {{ office.office_layer_name }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/backend/organograms/${office.id}/edit`" tabindex="-1">
                {{ office.ministry_name }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/backend/organograms/${office.id}/edit`" tabindex="-1">                 
                <status-level :status="office.status"></status-level>
              </Link>
            </td>
            <td class="w-px border-t">
              <Link class="flex items-center px-4" :href="`/backend/organograms/${office.id}/edit`" tabindex="-1">
                <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              </Link>
            </td>
          </tr>
          <tr v-if="offices.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="4">No Office Organograms  found.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="offices.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import StatusLevel from '@/Shared/StatusLevel'
import Breadcrumbs from '@/Shared/Breadcrumbs'
export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
    StatusLevel,
    Breadcrumbs
  },
  layout: Layout,
  props: {
    filters: Object,
    offices: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
      type:"index",
      title:"Office Organograms",
      url:'',
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/backend/organograms', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
